module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Review pa2-m pa4-l"
  }, [_c('div', {
    staticClass: "mw7-ns center"
  }, [(_vm.isTotalInvalid) ? _c('div', {
    staticClass: "pv3"
  }, [_vm._m(0)]) : _vm._e(), (_vm.quantities.books < 10) ? _c('div', {
    staticClass: "pv3"
  }, [_vm._m(1)]) : _c('div', [_c('div', {
    staticClass: "flex flex-auto flex-wrap"
  }, [_c('div', {
    staticClass: "w-100 w-60-ns pa2 w-100-ns"
  }, [_c('div', {
    staticClass: "Box"
  }, [_c('div', {
    staticClass: "BoxQuantity"
  }, [_vm._v(_vm._s(_vm.quantities.books))]), _c('div', {
    staticClass: "BoxText"
  }, [_vm._v("books")])])]), (_vm.showPrices) ? _c('div', {
    staticClass: "w-100 w-40-ns pa2"
  }, [_c('div', {
    staticClass: "Box"
  }, [_c('div', {
    staticClass: "BoxQuantity green"
  }, [_vm._v(_vm._s(_vm._f("price")(_vm.oneBookPrice)))]), _c('div', {
    staticClass: "BoxText"
  }, [_vm._v("per book (" + _vm._s(this.settings.currency) + ")")])])]) : _vm._e()]), _c('div', {
    staticClass: "flex flex-auto flex-wrap mb4"
  }, [_c('div', {
    staticClass: "w-100 w-60-ns pa2 w-100-ns"
  }, [_c('div', {
    staticClass: "Box mb3"
  }, [_c('div', {
    staticClass: "BoxQuantity"
  }, [_vm._v(_vm._s(_vm.quantities.pages))]), _c('div', {
    staticClass: "BoxText"
  }, [_vm._v("pages per book")])]), _c('div', {
    staticClass: "Box"
  }, [(_vm.discountPrice > 0) ? _c('div', {
    staticClass: "BoxQuantity"
  }, [_vm._v(_vm._s(_vm._f("price")(_vm.discountPrice)))]) : _vm._e(), (_vm.discountPrice > 0) ? _c('div', {
    staticClass: "BoxText"
  }, [_vm._v("Quantity discount")]) : _c('div', {
    staticClass: "BoxText",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("No quantity discount")])])]), (_vm.showPrices) ? _c('div', {
    staticClass: "flex flex-auto flex-wrap w-100 w-40-ns pa2"
  }, [_c('div', {
    staticClass: "Box Box--total w-100"
  }, [_c('div', {
    staticClass: "BoxTotalPrice"
  }, [_vm._v(_vm._s(_vm._f("price")(_vm.totalPrice)))]), _c('div', {
    staticClass: "BoxText"
  }, [_vm._v("Total price (" + _vm._s(this.settings.currency) + ")")])])]) : _vm._e()])]), _c('div', {
    staticClass: "Section"
  }, _vm._l((_vm.categoriesSummaries), function(categorySummary, catI) {
    return (!_vm.isCategoryIndexDisabled[catI]) ? _c('div', {
      staticClass: "Option flex justify-between items-center"
    }, [_c('div', [_c('div', {
      staticClass: "OptionCategory"
    }, [_vm._v(_vm._s(categorySummary.category))])]), _c('div', [(_vm.invalidCategoriesIndexes.includes(catI)) ? _c('div', {
      staticClass: "dark-red"
    }, [_vm._v("Unavailable")]) : _c('span', [_vm._v(_vm._s(_vm._f("ratio")(categorySummary.name)))])])]) : _vm._e()
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Box dark-red"
  }, [_c('strong', [_vm._v("Error:")]), _vm._v(" One of your selected options is now unavailable."), _c('br', {
    staticClass: "dn db-ns"
  }), _vm._v("\nPlease review your choices below.\n")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Box dark-red"
  }, [_c('strong', [_vm._v("Error:")]), _vm._v(" You must choose a book quantity\nin order to proceed to making an estimate.\n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74ebb0cd!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookartReview/BookartReview.vue
// module id = 192
// module chunks = 2